import { API } from "aws-amplify";
import { GRAPHQL_AUTH_MODE, GraphQLQuery } from "@aws-amplify/api";
import { GetResultQuery, GetResultQueryVariables } from "../../API";
import * as queries from "../../graphql/queries";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";

export const DefaultOEMKey = "REFERENCEDATA/defaultKey.png";

export const getOnlyMatchToOEM = async (
  bucket: string,
  top_k: number,
  filters: any,
  namespace: string | null = null
) => {
  try {
    const subscriptionId = uuidv4();
    const result = await API.graphql<GraphQLQuery<GetResultQuery>>({
      query: queries.getResult,
      variables: {
        id: subscriptionId,
        bucket: bucket,
        key: DefaultOEMKey,
        top_k: top_k,
        filter: JSON.stringify({
          $and: filters,
        }),
        model: "vit_small_patch16_224",
        task_name: "TecRMI",
        namespace: namespace,
      } as GetResultQueryVariables,
      authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
    });
    if (result.data) {
      let pinecone_response = result.data?.getResult;
      if (pinecone_response) {
        let parsed_results = JSON.parse(pinecone_response);
        return parsed_results.matches;
      }
    }
  } catch (error) {
    if (error instanceof Error) {
      console.error(error);
      toast(error.message, { type: "error" });
    } else {
      toast("An unknown error occurred", { type: "error" });
    }
  }
  return [];
};
